import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useParams, Link } from "react-router-dom";
import PropTypes from "prop-types";
import LogoFallback from "/img/logo.png";
import axios from "axios";
import he from 'he';

export default function EventsDetails({
  logoSrc = LogoFallback,
  accent = "#115e32",
  pageTitle = "Events | University of Creative Technology Chittagong",
}) {
	const { id } = useParams(); 
  // Update Browser Tab Title
	const [allnotice, setAllnotice] = useState([]);
	const [notice, setNotice] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [selectedNotice, setSelectedNotice] = useState(null); 
	
	const handlePost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				id:id,
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const response = await api.post("/events-details", payload);
			
			
			// Loop data (array)
			setNotice(response.data);
			setSelectedNotice(response.data[0]);
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	
	const noticePost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				department_id:'0',
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const response = await api.post("/recent-events", payload);
			
			
			// Loop data (array)
			setAllnotice(response.data || []);
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	
	useEffect(() => {
		handlePost();
		noticePost();
	}, []);
  useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  const rootStyle = {
    "--accent": accent,
    backgroundImage: `linear-gradient(135deg, var(--accent) 0%, rgba(17,94,50,0.85) 40%, rgba(255,255,255,0.03) 100%)`,
  };
	function decodetitle(rawTitle){
		const title = he.decode(rawTitle); 
		return title
	}
	function formatDate(dateStr) {
	  const date = new Date(dateStr);
	  return date.toLocaleDateString("en-GB", {
		day: "numeric",
		month: "long",
		year: "numeric",
	  });
	}
	function getFileMimeType(url) {
		if (!url) return "unknown";
		const q = url.split("?")[0].split("#")[0]; // remove query/hash
		const ext = q.split(".").pop()?.toLowerCase();
		if (["jpg","jpeg","png","gif","webp","svg"].includes(ext)) return "image";
		if (ext === "pdf") return "pdf";
		return "unknown";
	}
	let type ="";
	if(selectedNotice){
		type = getFileMimeType(import.meta.env.VITE_API_SOURCE_URL+selectedNotice.images); 
	}
	function textformat(textdata){
		let textinfo="";
		textinfo=textdata.replace(/\\n/g, '<br />');
		textinfo=textinfo.split('\\n').join('\n');
		textinfo=textinfo.split('\n').join('<br />');
		textinfo=textinfo.split('\\r').join(' ');
		textinfo=textinfo.split('\\').join(' ');
		return textinfo;
	}
  
  return (
    <div className="relative bg-gradient-to-r from-[#6BCCF2] to-teal-50 overflow-hidden">
      {/* Hero Section */}
	   <section className="relative py-20 text-center overflow-hidden">
        <div className="absolute inset-0 bg-[#fff8e1] opacity-40 -skew-y-3"></div>
        <motion.h1
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="relative z-10 text-4xl md:text-5xl font-bold text-[#014864]"
        >
         {selectedNotice ? (
			<span>
			{decodetitle(selectedNotice.name)}
			</span>
		 ) : (
			<span>Loading notice...</span>
		 )}
        </motion.h1>
        <p className="relative z-10 mt-4 text-gray-700 max-w-2xl mx-auto">
          Our uniform reflects discipline, identity, and modesty — ensuring every
          student represents UCTC with pride.
        </p>
		{/* Decorative bottom wave */}
        <div className="absolute bottom-0 left-0 right-0 -mt-6">
          <svg
            viewBox="0 0 1440 80"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full h-20"
          >
            <path
              d="M0,32 C240,96 480,0 720,32 C960,64 1200,16 1440,32 L1440 80 L0 80 Z"
              fill="#014864"
              opacity="0.92"
            />
          </svg>
        </div>
      </section>

      
        
     

      {/* Sub Section Content Body - Long Article */}
		<section className="bg-white py-16 px-6 sm:px-10 lg:px-20">
			<div className="max-w-7xl mx-auto p-6 grid grid-cols-1 md:grid-cols-3 gap-8">
			  {/* Left Column - Notice Details */}
			  <motion.div
				initial={{ opacity: 0, x: 40 }}
				whileInView={{ opacity: 1, x: 0 }}
				viewport={{ once: true }}
				transition={{ duration: 0.7 }}			  
				className="md:col-span-2 bg-white shadow rounded-lg p-6">
				{selectedNotice ? (
					<>
					<h1 className="text-2xl font-bold text-[#014864]  mb-2">
					  {decodetitle(selectedNotice.name)}
					</h1>
					<p className="text-sm text-gray-500 mb-4">{formatDate(selectedNotice.start_date)} to {formatDate(selectedNotice.end_date)}</p>
					<div
					  className="overflow-hidden break-words prose max-w-full"
					  dangerouslySetInnerHTML={{ __html: textformat(selectedNotice.description) }}
					></div>
					 {type === "image" && (
						
						<img
							src={`${import.meta.env.VITE_API_SOURCE_URL}${selectedNotice.images}`}
							alt="Notice"
							className="w-full object-cover rounded-lg shadow-md "
						/>
						
					)}
					{/* Example PDF Embed */}
					{type === "pdf" && (
						
						  <iframe
							src={`${import.meta.env.VITE_API_SOURCE_URL}${selectedNotice.images}`}
							title="Notice PDF"
							className="w-full h-64 md:h-96 lg:h-screen object-cover mt-4 border"
						  />
						
					)}
					</>
				) : (
					<p className="text-gray-600">Loading notice...</p>
				)}  
			  </motion.div>

			  {/* Right Column - Recent Notices */}
			  <div className="bg-gray-50 shadow rounded-lg p-4">
				<h2 className="text-lg font-semibold text-[#014864]  mb-4">
				  Recent Events
				</h2>
				<ul className="space-y-3">
				  {allnotice.slice(0, 15).map((n) => (
					<motion.li 
					initial={{ opacity: 0, x: 40 }}
					whileInView={{ opacity: 1, x: 0 }}
					viewport={{ once: true }}
					transition={{ duration: 0.7 }}	
					key={n.id} onClick={() => setSelectedNotice(n)} className="border-b pb-2 last:border-none cursor-pointer transition">					  
						<p className="text-sm text-gray-500">{formatDate(n.start_date)} to {formatDate(n.end_date)}</p>
						<p className="font-medium text-gray-800 truncate">{decodetitle(n.name)}</p>					 
					</motion.li>
				  ))}
				</ul>

				<div className="text-right mt-4">
				  <Link
					to="/all-events"
					className="text-[#014864] hover:underline text-sm font-medium"
				  >
					See All Events →
				  </Link>
				</div>
			  </div>
			</div>
      </section>
    </div>
  );
}

EventsDetails.propTypes = {
  logoSrc: PropTypes.string,
  accent: PropTypes.string,
  pageTitle: PropTypes.string,
};

